import { makeStyles } from '@mui/styles';

export const useStyles = makeStyles((theme) => ({
  dynamicBackground: {
    // Default mobile style (just pink background)
    backgroundColor: '#D5316B',

    // Tablet styles
    '@media (min-width: 600px)': {
      background: 'url("/images/11th-anniversary-tablet.png") #D5316B',
      backgroundSize: 'cover',
      backgroundPosition: 'center',
      backgroundRepeat: 'no-repeat',
    },

    // Desktop styles
    '@media (min-width: 960px)': {
      background: 'url("/images/11th-anniversary-desktop.png") #D5316B',
      backgroundSize: 'cover',
      backgroundPosition: 'center',
      backgroundRepeat: 'no-repeat',
    },

    position: 'relative',
  },

  secondaryColor: {
    color: '#D6246E',
  },
  titleExpired: {
    color: '#7833FF',
    marginBottom: theme.spacing(2),
  },
  graphiteColor: {
    color: theme.palette.grey[800],
  },
  delColor: {
    color: theme.palette.grey[800],
    textDecorationColor: '#FF0000',
    marginRight: theme.spacing(1.4),
  },
  contentRight: {
    paddingLeft: theme.spacing(9),
  },
  contentLeft: {
    paddingLeft: theme.spacing(2),

    '& h2': {
      marginTop: theme.spacing(2),
    },
  },
  buttonOffer: {
    backgroundColor: '#D6246E',
    color: theme.palette.common.white,
    borderRadius: 35,
    marginTop: theme.spacing(3),
    padding: theme.spacing(1.5, 4),
    textTransform: 'none',
    fontSize: 16,

    '&:hover': {
      backgroundColor: '#C10F59',
    },
  },
  mainBoxInformation: {
    border: '1px solid #707070',
    background: '#F8F8F8',
    borderRadius: 19,
    position: 'relative',
    padding: theme.spacing(7, 5),
    marginTop: theme.spacing(6),
    marginBottom: theme.spacing(6),
    backgroundColor: theme.palette.common.white,
  },
  faqBox: {
    background: '#F8F8F8',
    padding: theme.spacing(7, 5),
    backgroundColor: theme.palette.common.white,
  },
  featuresBoxInformation: {
    position: 'relative',
    color: '#7833FF',

    // '&::before': {
    //   display: 'block',
    //   position: 'absolute',
    //   top: 20,
    //   left: -40,
    //   content: '""',
    //   width: 30,
    //   height: 5,
    //   backgroundColor: '#7833FF',
    // },
  },
  textNewSubscribers: {
    color: '#949494',
    fontSize: 12,
  },
  contentCenter: {
    position: 'relative',
    zIndex: 2,
    padding: theme.spacing(4),
    maxWidth: '800px',
    margin: '0 auto',
  },
  mainHeading: {
    color: '#FFFFFF',
    fontSize: '2.5rem',
    fontWeight: 700,
    marginBottom: theme.spacing(1),
    [theme.breakpoints.down('sm')]: {
      fontSize: '2rem',
    },
  },
  subHeading: {
    color: '#FFFFFF',
    fontSize: '1.8rem',
    marginBottom: theme.spacing(3),
    [theme.breakpoints.down('sm')]: {
      fontSize: '1.5rem',
    },
  },
  callToAction: {
    color: '#FFFFFF',
    fontSize: '1.5rem',
    marginBottom: theme.spacing(4),
    [theme.breakpoints.down('sm')]: {
      fontSize: '1.2rem',
    },
  },
  subscribeButton: {
    backgroundColor: '#FFFFFF',
    color: '#D5316B',
    padding: '12px 32px',
    borderRadius: '30px',
    fontWeight: 'bold',
    '&:hover': {
      backgroundColor: '#F0F0F0',
    },
  },
  illustrationsContainer: {
    position: 'absolute',
    top: 0,
    left: 0,
    right: 0,
    bottom: 0,
    zIndex: 1,
    overflow: 'hidden',
  },
  backgroundIllustrations: {
    objectPosition: 'center',
  },
}));
